module.exports = __webpack_public_path__ + "img/3.3b0a3135.png";